<template>
  <div>
     <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> 
        <span class="child">/ Exam-Type Question-Type Mapping</span>
    </v-row><br />
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center class="heading">
        <h3>Exam-Type Question-Type Mapping</h3>
    </center>
    <!-- <span v-if="org!=null">
        <center>
            <h3>
                <v-chip class="ma-2" color="indigo" text-color="white">
                    <v-avatar left>
                        <v-icon size="22">home_work</v-icon>
                    </v-avatar>
                    {{org.name}}
                </v-chip>
            </h3>
        </center>
    </span> -->
    <template v-if="load==true">
      <v-data-table :headers="headers" :items="mapping_list" class="elevation-1" :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="button"
                  v-on="on"
                  @click="iseditable=!iseditable"
                >New Mapping</v-btn>
              </template>
              <v-card>
                <v-card-title class="heading">
                  <span>{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          dense
                          v-model="editedItem.exam_type"
                          :items="exam_type_list"
                          
                          item-text="exam_type"
                          item-value="id"
                          label="Exam Type"
                          persistent-hint
                          
                          :hint="iseditable?'Select Exam Type :: ESE,MSE,Summer etc...':'Change Exam Type :: ESE,MSE,Summer etc...'"
                          
                          return-object
                          single-line
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          dense
                          v-model="editedItem.question_type"
                          :items="question_type_list"
                          
                          item-text="question_type"
                          item-value="id"
                          label="Question Type"
                          persistent-hint

                          :hint="iseditable?'Question Types':'Change Question Types'"
                          
                          return-object
                          single-line
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          dense
                          v-model="editedItem.isactive"
                          color="success"
                          label="Active?"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    iseditable: false,
    load: false,
    dialog: false,
    mapping_list: null,
    exam_type_list: null,
    question_type_list: null,
    org:null,
    search: "",
    headers: [
      { text: "Exam Type", value: "exam_type" },
      { text: "Question Type", value: "question_type" },
      { text: "IsActive", value: "isactive" },
      { text: "Actions", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: 0,
      exam_type: "",
      question_type: "",
      isactive: ""
    },
    defaultItem: {
      id: 0,
      exam_type: "",
      question_type: "",
      isactive: ""
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Mapping" : "Edit Mapping";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    }
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad(){
      axios
      .post("/examination/examTypeQuestionTypeMapping")
      .then(res => {
        if (res.data.msg == "200") {
          this.exam_type_list = res.data.exam_type_list;
          this.question_type_list = res.data.question_type_list;
          this.mapping_list = res.data.mapping_list;
          this.org = res.data.organization
          this.load = true;
        } else {
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(() => {
        "use strict";
        var overlay = false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.iseditable = false;
      this.editedIndex = this.mapping_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        //  console.log("edit.." + this.editedItem);
        this.iseditable = false;
        axios
          .post("/examination/editExamTypeQuestionTypeMapping", this.editedItem)
          .then(res => {
              if (res.data.code == "SUCCESS") {
                //Object.assign(this.mapping_list[this.editedIndex],this.editedItem);
                this.showSnackbar("#4caf50", "Mapping updated successfully..."); // show snackbar on success
                this.onLoad();
              } else if(res.data.code == "NA"){
                this.showSnackbar("#b71c1c", "Something went wrong...Please try again later!"); // show snackbar
              }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            "use strict";
            var overlay = false;
          });
      } else {
        if(this.editedItem.question_type =='' || this.editedItem.exam_type == ''){
          this.showSnackbar("#b71c1c", "Exam type and Question type are mandatory!!!"); // show snackbar on error
        } else{
          axios
          .post("/examination/saveExamTypeQuestionTypeMapping", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
              this.mapping_list.push(this.editedItem);
              this.showSnackbar("#4caf50", "New Mapping Added Successfully..."); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              //alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Mapping Already Present!!!"); // show snackbar on error
            }
            this.onLoad();
          })
          .catch(error => {
            window.console.log(error);
          })
          .finally(() => {
            "use strict";
            var overlay = false;
          });
        }
      }
      this.close();
    }
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>